<script lang="ts">
  import { browser } from '$app/environment';
  import {
    datetimeInputToISO,
    formatShortDate,
    newDateWithOffset,
  } from '../../helpers/date-helper';
  import { CalendarAlt2Icon, ClockAltIcon } from '../../components/icons';
  import { Input } from 'core-components';
  import SveltyPicker from 'svelty-picker';

  export let date = '';
  export let time = '';
  export let errors = [];

  let datePickerVisible = false;

  $: datetime = datetimeInputToISO(date, time);

  $: dateError = errors.find(x => x.field === 'date');
  $: timeError = errors.find(x => x.field === 'time');

  const isIos =
    browser && /(iPad|iPhone|iPod|Safari)/g.test(navigator.userAgent);
</script>

<div class="datetime-picker">
  <div class="date-picker" class:is-ios={isIos}>
    <Input
      label="Preferred Date"
      placeholder="Select a Date"
      value={date ? formatShortDate(newDateWithOffset(date)) : ''}
      readonly
      size="2xlarge"
      error={!!dateError}
      errorMessage={dateError?.message}
      extend
    >
      <CalendarAlt2Icon slot="iconRight" />
    </Input>
    <SveltyPicker
      bind:value={date}
      displayFormat="j. n. Y"
      displayFormatType="php"
      bind:pickerOnly={datePickerVisible}
    />
  </div>

  <div class="time-picker">
    <Input
      label="Preferred Time"
      placeholder="Select a Time"
      value={time}
      readonly
      size="2xlarge"
      error={!!timeError}
      errorMessage={timeError?.message}
      extend
    >
      <ClockAltIcon slot="iconRight" />
    </Input>
    <SveltyPicker bind:value={time} format="hh:ii" displayFormat="HH:ii P" />
  </div>
  <input type="hidden" name="appointmentDatetime" value={datetime} />
</div>

<style lang="scss">
  .datetime-picker {
    display: flex;
    gap: var(--spacing-middle-md);
  }

  .date-picker,
  .time-picker {
    position: relative;
    display: flex;
    flex-grow: 1;
  }

  @media screen and (max-width: 991px) {
    .datetime-picker {
      flex-direction: column;
      gap: var(--spacing-middle-md);
      margin-bottom: 0;
    }

    .date-picker,
    .time-picker {
      width: 100%;
      height: auto;
    }
  }

  :global(.std-component-wrap) {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: -5px;
    z-index: 3;
  }

  :global(.std-component-wrap input[type='text']) {
    cursor: pointer;
    opacity: 0;
    height: 100%;
    width: 100%;
    z-index: 3;
  }

  :global(.std-calendar-wrap) {
    z-index: 3 !important;
  }
</style>
